export default __webpack_public_path__ + "cd63e5c9b3727ea8a46311a2bbbf8d18.png";